
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PositionItemProps } from ".";
import { loading, update } from "store/position";

interface ApiPositionUpdateInputProps extends PositionItemProps {
}

type ApiPositionUpdateOutputProps = OutputBaseProps<{ item: PositionItemProps; }, ApiPositionUpdateInputProps>

export const apiPositionUpdate = async (data: ApiPositionUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiPositionUpdateOutputProps>("/api/position/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};